import AssignRoleModal from '@/components/modal/user/AssignRoleModal';
import Button from '@/components/ui/button';
import { useModal } from '@/hooks/useModal';
import { DataCard } from '@/interfaces/common/DataCard';

const DetailUserCard = ({
	title,
	subTitle,
	avatar,
	data,
	showButton,
	refetch,
}: {
	title: string;
	subTitle: string;
	avatar: string;
	data: DataCard[];
	showButton?: boolean;
	refetch: () => void;
}) => {
	const {
		modal: assignRoleModal,
		openModal: openAssignRoleModal,
		closeModal: closeAssignRoleModal,
	} = useModal({
		children: (
			<AssignRoleModal
				closeModal={() => closeAssignRoleModal()}
				refetch={refetch}
			/>
		),
		closeOnOutClick: false,
		modalBoxClassName: 'max-w-6xl',
	});

	return (
		<div className="px-xlarge pt-large pb-xlarge rounded-rounded bg-grey-0 border-gray-300 border p-[2rem]">
			<div className="flex items-center gap-8">
				<div>
					<img
						src={avatar}
						alt="store"
						className="w-[70px] filter drop-shadow-lg"
					/>
				</div>
				<div className="flex flex-col">
					<h1
						className="font-inter text-grey-90 text-xl font-semibold truncate"
						data-test={`tittle-${title}`}
					>
						{title}
					</h1>
					<h3
						className="text-[15px] text-grey-50"
						data-test={`store-id-${subTitle}`}
					>
						{subTitle}
					</h3>
				</div>
			</div>
			<div className="flex justify-between items-end">
				<div className="mt-6 flex space-x-6 divide-x">
					{data.map((item, index) => (
						<div
							className={`flex flex-col ${index !== 0 ? 'pl-6' : ''}`}
							key={`${item.value}-${index}`}
						>
							<div className="inter-smaller-regular text-grey-50 mb-1">
								{item.name}
							</div>
							<div>{item.value}</div>
						</div>
					))}
				</div>
				{showButton && (
					<Button
						size="mini"
						color="success"
						shape="rounded"
						transition="none"
						onClick={openAssignRoleModal}
						data-test="assign-role-button"
					>
						Make admin
					</Button>
				)}
			</div>
			{assignRoleModal}
		</div>
	);
};

export default DetailUserCard;
